export default __webpack_public_path__ + "static/media/instagram.038941d2.svg";